import {UserUpdate} from '../../graphql/API';
import {IUserService} from './IUserService';
import {UserRepository} from './UserRepository';

export class UserService implements IUserService {
  userRepository: UserRepository;
  constructor() {
    this.userRepository = new UserRepository();
  }

  async updateUser(
    userId: string,
    updatedAt: string,
    user: UserUpdate,
  ): Promise<any> {
    return this.userRepository.updateUser(userId, updatedAt, user);
  }
  async createUser(
    cognitoUserId: string,
    country: string,
    whatsappNumber: string,
  ): Promise<any> {
    let user = await this.userRepository.createUser(
      cognitoUserId,
      country,
      whatsappNumber,
    );
    return user.data.createUser;
  }
  async adminCreateCognitoUser(
    phoneNumber: string,
    email: string,
    password: string,
  ): Promise<any> {
    let user = await this.userRepository.adminCreateCognitoUser(
      phoneNumber,
      email,
      password,
    );
    return user.data?.adminCreateCognitoUser;
  }
}
